import { render, staticRenderFns } from "./ActionDetail.vue?vue&type=template&id=fa467c5e&scoped=true&"
import script from "./ActionDetail.vue?vue&type=script&lang=js&"
export * from "./ActionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ActionDetail.vue?vue&type=style&index=0&id=fa467c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa467c5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
